import React from 'react'

import i18n from 'live/services/i18n'
import LiveTooltip from 'live/components/ui/tooltip'

import { selectRequiredDependeciesByType } from './utils'
import { PackageResource } from '../http/api'
import { Row, CardContent } from './styles'
import { RequiredEntitiesStatusTag } from './Tag'

interface ChannelsCardProps {
    package: PackageResource
}

const ChannelsCard: React.VFC<ChannelsCardProps> = ({ package: pkg }) => {
    const channels = selectRequiredDependeciesByType(pkg.requiredEntities, 'IDENTIFIED_CHANNEL')

    if (!channels.length) {
        return null
    }

    return (
        <CardContent>
            <h3 className="title">{i18n('Channel identifications')}</h3>
            <div className="feature-table">
                <div className="feature-table-head">
                    <div className="col-md-4">{i18n('Channel identification')}</div>
                    <div className="col-md-3">{i18n('Mnemonic')}</div>
                    <div className="col-md-5">{i18n('Validation')}</div>
                </div>
                <div className="feature-table-body">
                    {channels?.map((channel, index) => (
                        <ChannelItem key={index} channel={channel} />
                    ))}
                </div>
            </div>
        </CardContent>
    )
}

interface ChannelItemProps {
    channel: EntityRequirementResource
}

const ChannelItem: React.VFC<ChannelItemProps> = ({ channel }) => {
    return (
        <Row className="feature-table-row">
            {/* TODO: rename key to identifier */}

            <div className="col-md-4">
                <LiveTooltip
                    position="right"
                    content={
                        <div style={{ textAlign: 'left' }}>
                            Name: {channel.entity?.name}
                            <br /> Identification: {channel.key}
                        </div>
                    }
                >
                    <div style={{ width: 'fit-content' }}>{channel.entity?.name || channel.key || ''}</div>
                </LiveTooltip>
            </div>

            <div className="col-md-3">{i18n(channel.entity?.mnemonic)}</div>

            <div className="col-md-5">
                <RequiredEntitiesStatusTag requiredEntity={channel} />
            </div>
        </Row>
    )
}

export default ChannelsCard
